import React from 'react'

type DomainUrlFieldProps = {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  error?: string
  autoFocus?: boolean
}

export default function DomainUrlField({
  value,
  onChange,
  placeholder = 'projectname',
  error,
  autoFocus,
}: DomainUrlFieldProps) {
  return (
    <div>
      <div className="relative h-11 rounded-sm border border-gray-200 bg-gray-50">
        <span className="pointer-events-none absolute inset-0 left-3 right-3 flex items-center">
          <span
            className={`font-circular text-base font-normal leading-5 tracking-normal ${
              value ? 'text-black' : 'text-muted-foreground'
            }`}
          >
            {value || placeholder}
          </span>
          {/* i18next-instrument-ignore */}
          <span className="ml-0.5 text-gray-500">.disco.ac</span>
        </span>

        <input
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          autoFocus={autoFocus}
          autoCapitalize="off"
          autoComplete="off"
          spellCheck={false}
          className="relative z-10 w-full h-full bg-transparent px-3 outline-none text-transparent caret-black placeholder-transparent font-circular text-base font-normal leading-5 tracking-normal"
        />
      </div>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  )
}
